var _rect, _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRecallIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.1,
    width: 120,
    height: 120,
    rx: 60,
    fill: "#0473EA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M92.8266 32.2622C90.6546 34.4341 87.1262 34.4341 84.9464 32.2622C82.7744 30.0902 82.7744 26.5617 84.9464 24.3819C87.1183 22.2099 90.6468 22.2099 92.8266 24.3819C94.9986 26.5539 94.9986 30.0823 92.8266 32.2622Z",
    stroke: "#3078FF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.0541 95.61C32.8822 97.782 29.3537 97.782 27.1739 95.61C25.0019 93.4381 25.0019 89.9096 27.1739 87.7298C29.3459 85.5578 32.8743 85.5578 35.0541 87.7298C37.2261 89.9018 37.2261 93.4302 35.0541 95.61Z",
    stroke: "#3078FF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M51.5508 101.993C54.2795 102.541 57.1022 102.824 59.9956 102.824C83.6442 102.824 102.816 83.6523 102.816 60.0038C102.816 49.6771 99.1616 40.2051 93.0769 32.811",
    stroke: "#3078FF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M68.5268 18.0231C65.7745 17.4664 62.9204 17.1763 60.0035 17.1763C36.3471 17.1763 17.1758 36.3476 17.1758 59.9962C17.1758 70.3228 20.8297 79.7948 26.9144 87.1889",
    stroke: "#3078FF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M59.9957 72.6438C53.0094 72.6438 47.356 66.9825 47.356 60.004C47.356 53.0255 53.0172 47.3643 59.9957 47.3643C66.9743 47.3643 72.6355 53.0255 72.6355 60.004C72.6355 66.9825 66.9743 72.6438 59.9957 72.6438ZM85.2047 54.5388C84.5382 51.4494 83.3307 48.5718 81.6684 45.9999L85.0008 42.6675L77.3009 34.9754L73.9685 38.3079C71.4045 36.6456 68.519 35.4302 65.4296 34.7715V30.0591H54.5462V34.7715C51.4569 35.438 48.5792 36.6456 46.0073 38.3079L42.6749 34.9754L34.975 42.6675L38.3074 45.9999C36.6451 48.5639 35.4298 51.4494 34.7711 54.5388H30.043V65.4222H34.7711C35.4376 68.5115 36.6451 71.3892 38.3074 73.9611L34.9593 77.3092L42.6514 85.0091L45.9995 81.661C48.5713 83.3233 51.449 84.5386 54.5384 85.1973V89.9411H65.4217V85.1973C68.5111 84.5308 71.3888 83.3233 73.9606 81.661L77.3088 85.0091L85.0008 77.3092L81.6527 73.9611C83.315 71.3892 84.5304 68.5115 85.189 65.4222H89.9172V54.5388H85.189H85.2047Z",
    fill: "#3078FF",
    stroke: "#3078FF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecallIcon);
export default __webpack_public_path__ + "static/media/recall-icon.2a2f0f98a1d6f6d75abe1ac5238322d3.svg";
export { ForwardRef as ReactComponent };